export const filterKeys = {
    textSearch: 'text_search',
    types: 'school_types',
    educationalBranches: 'educational_branches',
    careServices: 'care_services',
    studentGuides: 'student_guides',
    measureTypes: 'measure_types',
    measureStatus: 'measure_status',
};
